import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="plan-by-obra-social"
export default class extends Controller {
  static targets = ["obraSocialInput", "obraSocialHidden", "planSelect"]
  static values = { url: String }

  connect() {
    this.lastObraSocialCode = this.obraSocialCode()

    if (this.lastObraSocialCode) {
      this.loadPlans({ preserveSelection: true })
    } else {
      this.resetPlanSelect({ disabled: true })
    }
  }

  onAutocompleteSelected() {
    this.onObraSocialChanged()
  }

  onObraSocialInput() {
    this.obraSocialHiddenTarget.value = ""
    this.onObraSocialChanged()
  }

  onObraSocialChanged() {
    const currentCode = this.obraSocialCode()
    if (currentCode === this.lastObraSocialCode) return

    this.lastObraSocialCode = currentCode

    if (!currentCode) {
      this.resetPlanSelect({ disabled: true })
      return
    }

    this.loadPlans({ preserveSelection: false })
  }

  async loadPlans({ preserveSelection }) {
    const codigoObraSocial = this.obraSocialCode()
    if (!codigoObraSocial) {
      this.resetPlanSelect({ disabled: true })
      return
    }

    const selectedBeforeLoad = preserveSelection ? this.planSelectTarget.value : ""
    this.setLoadingState()

    try {
      const response = await fetch(`${this.urlValue}?codigo_obra_social=${encodeURIComponent(codigoObraSocial)}`, {
        headers: { Accept: "application/json" }
      })

      if (!response.ok) {
        this.resetPlanSelect({ disabled: false })
        return
      }

      const plans = await response.json()
      this.populatePlanOptions(plans, selectedBeforeLoad)
    } catch (_error) {
      this.resetPlanSelect({ disabled: false })
    }
  }

  setLoadingState() {
    this.planSelectTarget.innerHTML = ""
    this.addOption("", "Cargando planes...")
    this.planSelectTarget.disabled = true
  }

  resetPlanSelect({ disabled }) {
    this.planSelectTarget.innerHTML = ""
    this.addOption("", "Seleccione un plan")
    this.planSelectTarget.value = ""
    this.planSelectTarget.disabled = disabled
  }

  populatePlanOptions(plans, selectedValue) {
    this.planSelectTarget.innerHTML = ""
    this.addOption("", "Seleccione un plan")

    plans.forEach((plan) => {
      this.addOption(plan.value, plan.label)
    })

    if (selectedValue && this.optionExists(selectedValue)) {
      this.planSelectTarget.value = selectedValue
    } else {
      this.planSelectTarget.value = ""
    }

    this.planSelectTarget.disabled = false
  }

  addOption(value, label) {
    const option = document.createElement("option")
    option.value = value
    option.textContent = label
    this.planSelectTarget.appendChild(option)
  }

  optionExists(value) {
    return Array.from(this.planSelectTarget.options).some((option) => option.value === value)
  }

  obraSocialCode() {
    return this.obraSocialHiddenTarget.value.toString().trim()
  }
}
